export default {
  install (Vue, options) {
    Vue.getUser = () => {
      if (localStorage.user) {
        try {
          let user = JSON.parse(localStorage.user)
          return user
        } catch (e) {
          return null
        }
      } else {
        return null
      }
    }

    Vue.setUser = (user) => {
      localStorage.user = JSON.stringify(user)
    }

    Vue.logout = (cb) => {
      delete localStorage.user
      if (cb) cb()
    }

    Vue.prototype.$getUser = () => {
      return Vue.getUser()
    }

    Vue.prototype.$setUser = (user) => {
      Vue.setUser(user)
    }

    Vue.prototype.$logout = (cb) => {
      Vue.logout(cb)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/auth.js